import type { History } from "history";
import { Application } from "../Application";
import { Bootstrapper } from "../Bootstrapper";
import { history } from "../RoutingAndStore";

declare module "../ApplicationAliases" {
    interface ApplicationAliases {
        History: History;
    }
}

export class HistoryBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): MaybePromise<void> {
        Application.bind("History", history);
    }
}
